    export class Errors {

        constructor() {
            this.errors = {}
        }

        has(field) {
            return this.errors.hasOwnProperty(field);
        }

        any() {
            return Object.keys(this.errors).length > 0;
        }

        get(field){

            if (this.errors[field]) {
                return this.errors[field][0];
            }

        }

        record(errors){
            // Respostas que nao sao de validacao (ex.: 403/500) nao trazem `errors`.
            // Sem o fallback, this.errors viraria undefined e has()/get() quebrariam
            // ("Cannot read properties of undefined (reading 'hasOwnProperty')").
            this.errors = errors || {};
        }

        clear(field) {
            if(field) {
                delete this.errors[field];
            }
            this.errors = {};
        }

    }

    export class Form {

        constructor(data) {

            //deep copy data to reset form
            this.originalData = JSON.parse(JSON.stringify(data));
            this.data = data;
            this.errors = new Errors();

        }

        reset() {

            this.data = JSON.parse(JSON.stringify(this.originalData));

            //this.errors.clear();

        }

        fill(object){
            object = JSON.parse(JSON.stringify(object));
            for (let prop in this.data){
                if(object.hasOwnProperty(prop))
                    this.data[prop] = object[prop];
            }
        }

        post(url, params= {}, headers={}) {
            //cria novo

            return new Promise( (resolve, reject) => {

                axios.post(url, this.data, {params:params, headers:headers})
                .then(response => {
                    this.onSuccess(response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    let errorObj = error.response?error.response.data:error;
                    if(!!error.response)
                        this.onFail(errorObj);
                    if (error.response && errorObj && typeof errorObj === 'object') {
                        errorObj._httpStatus = error.response.status;
                    }
                    reject(errorObj);
                    console.error(errorObj);
                });

            });

        }

        put(url, params= {}, headers={}) {
            //salva
            return new Promise( (resolve, reject) => {

                axios.put(url, this.data, {params:params, headers:headers})
                .then(response => {
                    this.onSuccess(response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    this.onFail(error.response.data);
                    reject(error.response.data);
                });

            });

        }

        onSuccess(response) {

            this.errors.clear();

        }

        onFail(error) {

            this.errors.record(error.errors);

        }

    }

    export class RequestQueue {

        constructor(showLoading = true){
            this.showLoading = showLoading;
            this.q = async.queue(function(task, callback) {

                //chama a função em task.func, no contexto task.context com os parametros task.args
                // Garante que task.args seja um array antes de usar o spread operator
                const args = Array.isArray(task.args) ? task.args : [];
                task.context[task.func](...args)
                    .then(function(response) {
                        callback(response);
                    })
                    .catch(error=>{
                        console.error("Failed!", error);
                        callback('error');
                    })
            },1);

            this.q.drain = function() {
                //todos os items foram processados
                EventBus.$emit('isLoadingGeneral', false);
            };
        }

        /**
         * @param {context} context The function context
         * @param {Array, String} tasks The task name array or string
         * @param {function} callback The callback function
         * @param {Array} args The parameters array
         */
        push(context, tasks, callback=null, args=[]){
            //mostra o loading
            if(this.showLoading)
                EventBus.$emit('isLoadingGeneral', true);

            //só para funcionar para arrays ou não arrays
            if(!Array.isArray(tasks)){
                tasks = [tasks];
            }

            // Garante que args seja sempre um array
            if(!Array.isArray(args)){
                args = [];
            }

            //salva as tasks como objetos contendo a função e o contexto (necessário para executar a função)
            let taskObjects = [];
            tasks.forEach(function(task){
                taskObjects.push({context:context, func:task, args: args});
            });

            //coloca as tasks na queue
            this.q.push(taskObjects, (data)=>{
                if(data !== 'error' && callback){
                    callback(data);
                }
            });

        }

        kill(){
            this.q.kill();
        }
    }